import Immutable from 'immutable';

const LOAD = 'cropInsurancePrices/LOAD';
const LOAD_SUCCESS = 'cropInsurancePrices/LOAD_SUCCESS';
const LOAD_FAIL = 'cropInsurancePrices/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'cropInsurancePrices/LOAD_ADD_SUCCESS';
const LOAD_YEAR_SUCCESS = 'cropInsurancePrices/LOAD_YEAR_SUCCESS';


const initialState = Immutable.fromJS({
  CropInsurancePrices: null,
  CropInsurancePricesYears: null,
  loading: false,
  errorMessage: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('CropInsurancePrices', action.CropInsurancePrices);


    case LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('CropInsurancePrice', action.result);

    case LOAD_YEAR_SUCCESS:
    return state
    .set('loading', false)
    .set('CropInsurancePricesYears', action.CropInsurancePricesYears);


    default:
    return state;
  }
}

export const getCropInsurancePrices = (forYear) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/cropInsurancePrices/' + forYear);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, CropInsurancePrices: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getCropInsurancePricesYears = () => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/cropInsurancePrices/cropInsurancePricesYear');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_YEAR_SUCCESS, CropInsurancePricesYears: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};



export const addCropInsurancePrices = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {

    const res = await api.post('/cropInsurancePrices', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getCropInsurancePricesYears());
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const updateCropInsurancePrices = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {

    const res = await api.put('/cropInsurancePrices', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getCropInsurancePricesYears());
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const deleteCropInsurancePrices = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {

    const res = await api.del('/cropInsurancePrices', { data });

    if (res.message) {

      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getCropInsurancePricesYears());
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const getCropInsurancePricesById = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/cropInsurancePrices/cropInsurancePricesGetById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};


export const updateCropInsuranceDocuments = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {

    const res = await api.put('cropInsurancePrices/cropInsuranceDocuments', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getCropInsurancePricesYears());
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};



export const farmCrpUpload = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {

    const res = await api.post('cropInsurancePrices/farmCrpUpload', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};



export const deleteFarmCrpUpload = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {

    const res = await api.del('/cropInsurancePrices/cropUploads', { data });

    if (res.message) {

      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getCropInsurancePricesYears());
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const getFarmCrpUploads = (farm_id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/cropInsurancePrices/farmCrpUploads/' + farm_id);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};


export const getCropInsDocsById = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/cropInsurancePrices/getCropInsDocsById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const farmPreCrpUpload = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('cropInsurancePrices/farmPreCrpUpload', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getFarmPreCrpUploads = (farm_id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/cropInsurancePrices/farmPreCrpUploads/' + farm_id);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteFarmPreCrpUpload = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/cropInsurancePrices/propCasualUploads', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getCropInsurancePricesYears());
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


// WEBPACK FOOTER //
// ./src/redux/modules/cropInsurancePrices.js